
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import Marquee from "@/components/semantics/Marquee.vue";
import SortHeader from "@/components/base/table/header/SortHeader.vue";
import { Action, Getter, State } from "vuex-class";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { getAreaCN, deepClone, getParentArea } from "@/common/utils";
import { pageViewUnit } from "@/config";

@Component({
  name: "publicyList",
  components: {
    Marquee,
    SortHeader,
    Pagination,
  },
})
export default class Apply extends Vue {
  @Action("policy/getPublicyList") private getPublicyList: any;
  @Getter("cityName") private cityName: any;
  @Getter("city") private city: any;
  areaOption = this.$root.$data.areaOption;
  loading = false;
  tableData: any = [];
  total = 0;
  pages = 0;
  current = 1;
  size = 15;
  current_option: any = {};
  created() {
    this.getData(0);
  }
  toDetail({ id: publicyId }: any, column: any, e: any) {
    this.$router.push({
      path: "/detail/publicy",
      query: { publicyId },
    });
  }
  async getData(type: any) {
    // 0-default|1-search
    this.loading = true;
    let options: any = {
      pageNumber: this.current,
      pageSize: this.size,
      bigClass: "公示公告",
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.city.locationAddressCode,
    };
    if (type === 1) {
      options = {
        ...options,
        ...this.current_option,
      };
    } else {
      if (!this.city.locationAddressCode) {
        options.addressCode = this.city.id;
      }
      options = {
        ...options,
      };
    }
    this.getPublicyList(options)
      .then(({ code, result, msg }: any) => {
        if (code === 200) {
          const { total, list, pages } = result;
          const policy_arr: any = [];
          this.tableData = list.map((item: any) => {
            const addressCN = getAreaCN(this.areaOption, item.addressCode);
            item.pageView = (item.pageView || 0) + pageViewUnit;
            item.addressCN = addressCN ? addressCN.label : addressCN;
            console.log(item, 9999);
            return item;
          });
          this.total = total;
          this.pages = pages;
        }
      })
      .finally(() => (this.loading = false));
  }
  clickMarquee(options: any) {
    console.log(options, "options");
    options.addressCode ? options.addressCode : this.city.id;
    this.current_option = {
      addressCode: options.addressCode,
      departmentId: options.departmentId,
      nature: options.nature,
    };
    this.getData(1);
  }
  lastName(val: any) {
    if (val) {
      return val.split(",").pop();
    } else {
      return "--";
    }
  }
  search(options: any) {
    const filterOptions = {
      title: options.title,
    };
    this.current_option = {
      ...this.current_option,
      ...filterOptions,
    };
    this.getData(1);
  }
  currentChange(params: any) {
    this.current = params;
    this.getData(1);
  }
}
